import toast from 'react-hot-toast'
import { useAppDispatch } from '../../reducers/store'
import intelReportsStructure from './intel_reports_structure.json'
import imageMapping from '../adversaries/imageMapping'
import AdversaryCard from '../adversaries/AdversaryCard'
import { downloadReportPdf } from '../../reducers/adversaries'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { selectUser } from '../../reducers/users'
import { DEFAULT_TOAST_CONFIG } from '../toast/consts'

type ReportName = keyof typeof imageMapping

function IntelReportsWrapper() {
  const di = useAppDispatch()
  const { session } = useSelector(selectUser)
  const navigate = useNavigate()

  const adversariesWithImages = intelReportsStructure.map((intelReports) => ({
    ...intelReports,
    reports: intelReports.reports.map((report) => ({
      ...report,
      reportImage:
        (report.reportName as ReportName) in imageMapping
          ? imageMapping[report.reportName as ReportName]
          : report.reportImage,
    })),
  }))

  const downloadAdversaryReport = async (reportName: string) => {
    const bucket = import.meta.env.VITE_INTEL_REPORTS_BUCKET
    const downloaded = await di(downloadReportPdf(bucket, reportName))
    downloaded
      ? toast.success('Report successfully downloaded', DEFAULT_TOAST_CONFIG)
      : toast.error('Failed to download report, please try again', DEFAULT_TOAST_CONFIG)
  }

  useEffect(() => {
    if (session?.portalPreferences?.threatIntelAccess == false) {
      navigate('/dashboard')
    }
  }, [session])

  return (
    <>
      <div className="absolute top-18 left-52 rounded-tl-lg border-t border-l border-mainBorder bg-contentBackground w-[calc(100%_-_208px)] h-[calc(100%_-_74px)] p-9 overflow-y-auto">
        <div className="mx-auto max-w-[1200px]">
          {adversariesWithImages.map((adversaryGroup) => (
            <div className="mb-6" key={adversaryGroup.sectionName}>
              <p className="text-lg font-medium">{adversaryGroup.sectionName}</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-3">
                {adversaryGroup.reports.map((report) => (
                  <AdversaryCard
                    reportName={report.reportName}
                    reportImage={report.reportImage}
                    execSummary={report.execSummary}
                    downloadLink={report.downloadLink}
                    reportDate={report.date}
                    downloadTitle="Download Report"
                    downloadAction={downloadAdversaryReport}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default IntelReportsWrapper
